import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Subheader from "./Subheader";
import StateStore from "globalStates/Store";
import AppStore from "context";
import SideBar from './SideBar';
import useContextService from 'hooks/useContextService';
import { includes } from 'lodash';
import Loader from 'components/Loader';

const Next = () => {
  const location = useLocation();
  const { states, resetStates } = useContextService();
  const { loading } = states;

  useEffect(() => {
    const { pathname } = new URL(window.location.href);
    const hasPathChanged = !includes(pathname, '/rx-manager');
    if (hasPathChanged) {
      resetStates('claimsManager');
    }
  }, [location]);

  return (
    <>
      {loading && <Loader opacity={0.01} color='black' />}
      <Outlet />
    </>
  );
};


const Layout = (props) => {
  const { modules, onlOrgChange } = props;
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId);
    onlOrgChange(orgId)
  }

  return (
    // <AppStore>
    //   <StateStore>
    //     <section>
    //       <Header />
    //       <Subheader />
    //       <div className="content-wrapper bg-light">
    //         <Outlet />
    //       </div>
    //     </section>
    //   </StateStore>
    // </AppStore>


<AppStore>
<StateStore>
  <section>
    <Header onOrgChange={onOrgChange} />
    <div className='main-gird'>
      {/* <Sider modules={modules} /> */}
      <SideBar modules={modules} />
      {/* <SideBarone /> */}
      {/* <Subheader modules={modules} /> */}
      <div className='bg-light'>
        {/* content-wrapper */}
        <Next />
      </div>
    </div>
  </section>
</StateStore>
</AppStore>
  );
};

export default Layout;
